import importLink from './import-link.png'
import importModal from './import-modal.png'

export default [importLink, importModal]
